"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Configurator = void 0;
const plattar_api_1 = require("@plattar/plattar-api");
const object_hash_1 = __importDefault(require("object-hash"));
const remote_request_1 = require("./remote-request");
class Configurator {
    constructor() {
        this.quality = 100;
        this.output = "glb";
        this.server = "production";
        this.retry = 0;
        this._maps = [];
        this._attrHash = [];
    }
    add(sceneProduct = null, productVariation = null) {
        this.addSceneProduct(sceneProduct, productVariation);
    }
    addSceneProduct(sceneProduct = null, productVariation = null) {
        if (!sceneProduct) {
            throw new Error("Configurator.addSceneProduct() - sceneProduct input was null or undefined");
        }
        if (!productVariation) {
            throw new Error("Configurator.addSceneProduct() - productVariation input was null or undefined");
        }
        const map = {
            sceneproduct: null,
            productvariation: null
        };
        if ((sceneProduct instanceof plattar_api_1.SceneProduct) && (productVariation instanceof plattar_api_1.ProductVariation)) {
            map.sceneproduct = sceneProduct.id;
            map.productvariation = productVariation.id;
            this._maps.push(map);
            return;
        }
        if ((typeof sceneProduct === "string" || sceneProduct instanceof String) && (typeof productVariation === "string" || productVariation instanceof String)) {
            map.sceneproduct = sceneProduct;
            map.productvariation = productVariation;
            this._maps.push(map);
            return;
        }
        throw new Error("Configurator.addSceneProduct() - mismatched instance types for inputs");
    }
    addProduct(product = null, productVariation = null) {
        if (!product) {
            throw new Error("Configurator.addProduct() - product input was null or undefined");
        }
        if (!productVariation) {
            throw new Error("Configurator.addProduct() - productVariation input was null or undefined");
        }
        const map = {
            productvariation: null,
            product: null
        };
        if ((product instanceof plattar_api_1.Product) && (productVariation instanceof plattar_api_1.ProductVariation)) {
            map.product = product.id;
            map.productvariation = productVariation.id;
            this._maps.push(map);
            return;
        }
        if ((typeof product === "string" || product instanceof String) && (typeof productVariation === "string" || productVariation instanceof String)) {
            map.product = product;
            map.productvariation = productVariation;
            this._maps.push(map);
            return;
        }
        throw new Error("Configurator.addProduct() - mismatched instance types for inputs");
    }
    addModel(sceneModel = null) {
        if (!sceneModel) {
            throw new Error("Configurator.addModel() - sceneModel input was null or undefined");
        }
        const map = {
            scenemodel: null
        };
        if (sceneModel instanceof plattar_api_1.SceneModel) {
            map.scenemodel = sceneModel.id;
            this._maps.push(map);
            return;
        }
        if (typeof sceneModel === "string") {
            map.scenemodel = sceneModel;
            this._maps.push(map);
            return;
        }
        throw new Error("Configurator.addModel() - mismatched instance types for inputs");
    }
    get() {
        return new Promise((accept, reject) => {
            this._CalculateHash().then(() => {
                remote_request_1.RemoteRequest.request(this._GetPayload(), (this.retry < 0 ? 0 : this.retry)).then(accept).catch(reject);
            }).catch((_err) => {
                reject(new Error("Configurator.get() - one of the objects does not exist in Plattar API"));
            });
        });
    }
    _CalculateHash() {
        return new Promise((accept, reject) => {
            const promises = [];
            const oldOrigin = plattar_api_1.Server.default().originLocation.type;
            plattar_api_1.Server.create(plattar_api_1.Server.match(this.server));
            this._maps.forEach((map) => {
                if (map.productvariation) {
                    promises.push(new plattar_api_1.ProductVariation(map.productvariation).get());
                }
                if (map.sceneproduct) {
                    promises.push(new plattar_api_1.SceneProduct(map.sceneproduct).get());
                }
                if (map.scenemodel) {
                    promises.push(new plattar_api_1.SceneModel(map.scenemodel).get());
                }
                if (map.product) {
                    promises.push(new plattar_api_1.Product(map.product).get());
                }
            });
            Promise.all(promises).then((values) => {
                values.forEach((value) => {
                    this._attrHash.push(value.attributes);
                });
                // reset server back
                plattar_api_1.Server.create(plattar_api_1.Server.match(oldOrigin));
                accept();
            }).catch(() => {
                // reset server back
                plattar_api_1.Server.create(plattar_api_1.Server.match(oldOrigin));
                reject(new Error("Configurator._CalculateHash() - unexpected error"));
            });
        });
    }
    _GetPayload() {
        const converter = this.output === "vto" ? "config_to_reality" : "config_to_model";
        const load = {
            options: {
                converter: converter,
                quality: this.quality,
                output: this.output,
                server: this.server
            },
            data: {
                maps: this._maps
            }
        };
        if (this._attrHash.length > 0) {
            load.options.hash = object_hash_1.default.MD5(this._attrHash) + object_hash_1.default.MD5(load);
        }
        else {
            load.options.hash = object_hash_1.default.MD5(load);
        }
        return load;
    }
}
exports.Configurator = Configurator;
